export default {
  v: '5.5.2',
  fr: 24,
  ip: 0,
  op: 24,
  w: 60,
  h: 60,
  nm: 'loading',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: '“loading”轮廓',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { t: 0, s: [0], h: 1 },
            { t: 3, s: [45], h: 1 },
            { t: 6, s: [90], h: 1 },
            { t: 9, s: [135], h: 1 },
            { t: 12, s: [180], h: 1 },
            { t: 15, s: [225], h: 1 },
            { t: 18, s: [270], h: 1 },
            { t: 21, s: [315], h: 1 },
            { t: 24, s: [360], h: 1 }
          ],
          ix: 10
        },
        p: { a: 0, k: [30, 30, 0], ix: 2 },
        a: { a: 0, k: [10, 10, 0], ix: 1 },
        s: { a: 0, k: [300, 300, 100], ix: 6 }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.293, 0.293],
                    [0, 0],
                    [-0.293, -0.293],
                    [0, 0],
                    [0.293, -0.293],
                    [0.293, 0.293],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0.293, -0.293],
                    [0, 0],
                    [0.293, 0.293],
                    [-0.293, 0.293],
                    [0, 0],
                    [-0.293, -0.293]
                  ],
                  v: [
                    [-1.768, -1.768],
                    [-1.768, -1.768],
                    [-0.707, -1.768],
                    [1.768, 0.707],
                    [1.768, 1.768],
                    [0.707, 1.768],
                    [-1.768, -0.707]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 90, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [6.12, 6.111], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0.415],
                    [0, 0],
                    [-0.414, 0],
                    [0, 0],
                    [0, -0.414],
                    [0.415, 0],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, -0.414],
                    [0, 0],
                    [0.415, 0],
                    [0, 0.415],
                    [0, 0],
                    [-0.414, 0]
                  ],
                  v: [
                    [-2.5, 0],
                    [-2.5, 0],
                    [-1.75, -0.75],
                    [1.75, -0.75],
                    [2.5, 0],
                    [1.75, 0.75],
                    [-1.75, 0.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 80, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [4.509, 10], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.293, 0.293],
                    [0, 0],
                    [-0.293, 0.293],
                    [0, 0],
                    [-0.293, -0.293],
                    [0.293, -0.293],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [-0.293, -0.293],
                    [0, 0],
                    [0.293, -0.293],
                    [0.293, 0.293],
                    [0, 0],
                    [-0.293, 0.293]
                  ],
                  v: [
                    [-1.768, 1.768],
                    [-1.768, 1.768],
                    [-1.768, 0.707],
                    [0.707, -1.767],
                    [1.768, -1.767],
                    [1.768, -0.707],
                    [-0.707, 1.768]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 70, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [6.12, 13.889], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.415, 0],
                    [0, 0],
                    [0, 0.414],
                    [0, 0],
                    [-0.414, 0],
                    [0, -0.415],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [-0.414, 0],
                    [0, 0],
                    [0, -0.415],
                    [0.415, 0],
                    [0, 0],
                    [0, 0.414]
                  ],
                  v: [
                    [0, 2.5],
                    [0, 2.5],
                    [-0.75, 1.75],
                    [-0.75, -1.75],
                    [0, -2.5],
                    [0.75, -1.75],
                    [0.75, 1.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 60, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [10.009, 15.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0.293, -0.293],
                    [0, 0],
                    [0.293, 0.293],
                    [0, 0],
                    [-0.293, 0.293],
                    [-0.292, -0.293],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [-0.293, 0.293],
                    [0, 0],
                    [-0.293, -0.293],
                    [0.293, -0.293],
                    [0, 0],
                    [0.293, 0.293]
                  ],
                  v: [
                    [1.768, 1.768],
                    [1.768, 1.768],
                    [0.707, 1.768],
                    [-1.768, -0.707],
                    [-1.768, -1.767],
                    [-0.708, -1.767],
                    [1.768, 0.707]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 50, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [13.898, 13.889], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -0.414],
                    [0, 0],
                    [0.414, 0],
                    [0, 0],
                    [0, 0.415],
                    [-0.414, 0],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0, 0.415],
                    [0, 0],
                    [-0.414, 0],
                    [0, -0.414],
                    [0, 0],
                    [0.414, 0]
                  ],
                  v: [
                    [2.5, 0],
                    [2.5, 0],
                    [1.75, 0.75],
                    [-1.75, 0.75],
                    [-2.5, 0],
                    [-1.75, -0.75],
                    [1.75, -0.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 40, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [15.509, 10], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.293, -0.293],
                    [0, 0],
                    [0.293, -0.293],
                    [0, 0],
                    [0.293, 0.293],
                    [-0.293, 0.293],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0.293, 0.293],
                    [0, 0],
                    [-0.292, 0.293],
                    [-0.293, -0.293],
                    [0, 0],
                    [0.293, -0.293]
                  ],
                  v: [
                    [1.768, -1.768],
                    [1.768, -1.768],
                    [1.768, -0.707],
                    [-0.708, 1.768],
                    [-1.768, 1.768],
                    [-1.768, 0.707],
                    [0.707, -1.768]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 30, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [13.898, 6.111], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.414, 0],
                    [0, 0],
                    [0, -0.414],
                    [0, 0],
                    [0.414, 0],
                    [0, 0.415],
                    [0, 0]
                  ],
                  o: [
                    [0, 0],
                    [0.414, 0],
                    [0, 0],
                    [0, 0.415],
                    [-0.414, 0],
                    [0, 0],
                    [0, -0.414]
                  ],
                  v: [
                    [0, -2.5],
                    [0, -2.5],
                    [0.75, -1.75],
                    [0.75, 1.75],
                    [0, 2.5],
                    [-0.75, 1.75],
                    [-0.75, -1.75]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [10.009, 4.5], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: '变换'
            }
          ],
          nm: '组 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 288,
      st: 0,
      bm: 0
    }
  ],
  markers: []
}



// WEBPACK FOOTER //
// ./packages/dof-spinner/loading_white.js